import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5fa4062a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fas fa-search me-2" }),
    /*#__PURE__*/_createTextVNode("ค้นหาโครงการ")
  ]),
  /*#__PURE__*/_createElementVNode("h6", { class: "card-subtitle text-muted" }, "แสดงโครงการตามข้อมูลที่ต้องการใช้ค้นหา")
], -1))
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = {
  key: 1,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "alert-message" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "alert-heading" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "far fa-fw fa-bell me-2" }),
    /*#__PURE__*/_createTextVNode("เกิดข้อผิดพลาด!")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "กรุณาติดต่อผู้ดูแลระบบเพื่อกำหนดหน้าที่รับผิดชอบก่อน")
], -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!
  const _component_ProjectFilterComponent = _resolveComponent("ProjectFilterComponent")!
  const _component_ProjectTableComponent = _resolveComponent("ProjectTableComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.assigned)
                ? (_openBlock(), _createBlock(_component_ProjectFilterComponent, {
                    key: 0,
                    ref: "filterComponent",
                    mode: _ctx.mode,
                    "user-id": _ctx.userId,
                    keyword: _ctx.keyword,
                    onSubmit: _ctx.searchSubmit
                  }, null, 8, ["mode", "user-id", "keyword", "onSubmit"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
            ], 64))
      ])
    ]),
    (_ctx.assigned)
      ? (_openBlock(), _createBlock(_component_ProjectTableComponent, {
          key: 0,
          ref: "tableComponent",
          mode: _ctx.mode,
          "user-id": _ctx.userId,
          filter: _ctx.filter
        }, null, 8, ["mode", "user-id", "filter"]))
      : _createCommentVNode("", true)
  ], 64))
}